import React from 'react'

export default function Footer({ data }) {
  const { title, text } = data
  return (
    <div className='footer'>
      <h6 className='title'>{title}</h6>
      <div>
        <span className='text'>{text}</span>
      </div>
    </div>
  )
}
